import React from 'react';

export const PointIcon = () => (
    <svg width={20} height={20} viewBox="0 0 20 20">
        <g transform="translate(0,-1032.3622)">
            <path
                style={{
                    color: 'currentColor',
                    clipRule: 'nonzero',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    opacity: 1,
                    isolation: 'auto',
                    mixBlendMode: 'normal',
                    colorInterpolation: 'sRGB',
                    colorInterpolationFilters: 'linearRGB',
                    solidColor: 'currentColor',
                    solidOpacity: 1,
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'evenodd',
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none',
                    colorRendering: 'auto',
                    imageRendering: 'auto',
                    shapeRendering: 'auto',
                    textRendering: 'auto',
                    enableBackground: 'accumulate'
                }}
                d="m 36,1040.3622 c 6e-6,3.3093 -5.988612,10 -5.988612,10 0,0 -5.998776,-6.668 -6.011345,-9.9772 -0.01257,-3.3092 2.656576,-6.0039 5.965792,-6.0227 3.309189,-0.019 6.00884,2.6452 6.033992,5.9543"
            />
            <path
                style={{
                    color: 'currentColor',
                    clipRule: 'nonzero',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    opacity: 1,
                    isolation: 'auto',
                    mixBlendMode: 'normal',
                    colorInterpolation: 'sRGB',
                    colorInterpolationFilters: 'linearRGB',
                    solidColor: 'currentColor',
                    solidOpacity: 1,
                    fill: '#ffffff',
                    fillOpacity: 1,
                    fillRule: 'evenodd',
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none',
                    colorRendering: 'auto',
                    imageRendering: 'auto',
                    shapeRendering: 'auto',
                    textRendering: 'auto',
                    enableBackground: 'accumulate'
                }}
                d="m 34.000115,1040.3622 c -5e-6,2.2062 -3.992523,7.0001 -3.992523,7.0001 0,0 -3.999291,-4.7787 -4.007679,-6.9849 -0.0084,-2.2062 1.771082,-4.0027 3.97731,-4.0153 2.20621,-0.013 4.006037,1.7635 4.022777,3.9697"
            />
            <path
                style={{
                    color: 'currentColor',
                    clipRule: 'nonzero',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    opacity: 1,
                    isolation: 'auto',
                    mixBlendMode: 'normal',
                    colorInterpolation: 'sRGB',
                    colorInterpolationFilters: 'linearRGB',
                    solidColor: 'currentColor',
                    solidOpacity: 1,
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'evenodd',
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none',
                    colorRendering: 'auto',
                    imageRendering: 'auto',
                    shapeRendering: 'auto',
                    textRendering: 'auto',
                    enableBackground: 'accumulate'
                }}
                d="M 9.9667969,1014.3622 C 6.6575809,1014.381 3.98743,1017.0764 4,1020.3856 c 0.012569,3.3092 6.011719,8.9766 6.011719,8.9766 0,0 5.988287,-5.6907 5.988281,-9 l 0,-0.045 c -0.02515,-3.3091 -2.724014,-5.9741 -6.0332031,-5.9551 z m 0.00977,2 c 2.2062061,-0.013 4.0066931,1.7626 4.0234331,3.9688 l 0,0.031 c -5e-6,2.2062 -3.992188,6 -3.992188,6 0,0 -3.999424,-3.7782 -4.007812,-5.9844 -0.0084,-2.2062 1.7703345,-4.003 3.9765625,-4.0156 z"
            />
            <path
                style={{
                    opacity: 1,
                    fill: 'currentColor',
                    fillOpacity: 1,
                    stroke: 'none',
                    strokeWidth: 2,
                    strokeLinecap: 'butt',
                    strokeLinejoin: 'bevel',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    marker: 'none'
                }}
                d="M 10 2 C 6.686292 2 4 4.6863 4 8 C 4 11.3137 10 17 10 17 C 10 17 16 11.3137 16 8 C 16 4.6863 13.313708 2 10 2 z M 10 4 C 12.071068 4 13.75 5.6789 13.75 7.75 C 13.75 9.2053278 11.93111 11.644393 10.830078 13 L 9.1699219 13 C 8.0688903 11.644393 6.25 9.2053278 6.25 7.75 C 6.25 5.6789 7.928932 4 10 4 z "
                transform="translate(0,1032.3622)"
            />
        </g>
    </svg>
);

export const LineIcon = () => (
    <svg width={20} height={20} viewBox="0 0 20 20">
        <g transform="translate(0,-1032.3622)">
            <path
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 3,
                    marker: 'none',
                    enableBackground: 'accumulate'
                }}
                d="m 13.5,1035.8622 c -1.380712,0 -2.5,1.1193 -2.5,2.5 0,0.3208 0.04614,0.6244 0.15625,0.9063 l -3.75,3.75 c -0.281836,-0.1102 -0.585421,-0.1563 -0.90625,-0.1563 -1.380712,0 -2.5,1.1193 -2.5,2.5 0,1.3807 1.119288,2.5 2.5,2.5 1.380712,0 2.5,-1.1193 2.5,-2.5 0,-0.3208 -0.04614,-0.6244 -0.15625,-0.9062 l 3.75,-3.75 c 0.281836,0.1101 0.585421,0.1562 0.90625,0.1562 1.380712,0 2.5,-1.1193 2.5,-2.5 0,-1.3807 -1.119288,-2.5 -2.5,-2.5 z"
            />
        </g>
    </svg>
);

export const PolygonIcon = () => (
    <svg width={20} height={20} viewBox="0 0 20 20">
        <g transform="translate(0,-1032.3622)">
            <path
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 0.5,
                    marker: 'none',
                    enableBackground: 'accumulate'
                }}
                d="m 5,1039.3622 0,6 2,2 6,0 2,-2 0,-6 -2,-2 -6,0 z m 3,0 4,0 1,1 0,4 -1,1 -4,0 -1,-1 0,-4 z"
            />
            <circle
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 1.60000002,
                    marker: 'none',
                    enableBackground: 'accumulate'
                }}
                cx={6}
                cy={1046.3622}
                r={2}
            />
            <circle
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 1.60000002,
                    marker: 'none',
                    enableBackground: 'accumulate'
                }}
                cx={14}
                cy={1046.3622}
                r={2}
            />
            <circle
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 1.60000002,
                    marker: 'none',
                    enableBackground: 'accumulate'
                }}
                cx={6}
                cy={1038.3622}
                r={2}
            />
            <circle
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 1.60000002,
                    marker: 'none',
                    enableBackground: 'accumulate'
                }}
                cx={14}
                cy={1038.3622}
                r={2}
            />
        </g>
    </svg>
);

export const TrashIcon = () => (
    <svg width={20} height={20} viewBox="0 0 20 20">
        <g transform="translate(0,-1032.3622)">
            <path
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    visibility: 'visible',
                    fill: 'currentColor',
                    fillOpacity: 1,
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 0.99999982,
                    marker: 'none',
                    enableBackground: 'accumulate'
                }}
                d="m 10,1035.7743 c -0.7849253,8e-4 -1.4968376,0.4606 -1.8203125,1.1758 l -3.1796875,0 -1,1 0,1 12,0 0,-1 -1,-1 -3.179688,0 c -0.323475,-0.7152 -1.035387,-1.175 -1.820312,-1.1758 z m -5,4.5879 0,7 c 0,1 1,2 2,2 l 6,0 c 1,0 2,-1 2,-2 l 0,-7 -2,0 0,5.5 -1.5,0 0,-5.5 -3,0 0,5.5 -1.5,0 0,-5.5 z"
            />
        </g>
    </svg>
);

export const CircleIcon = () => (
    <svg width={20} height={20} viewBox="0 0 20 20">
        <g>
            <circle
                style={{
                    fill: 'none',
                    stroke: 'currentColor',
                    strokeWidth: 2
                }}
                cx={10}
                cy={10}
                r={7}
            />
            <circle
                style={{
                    fill: 'currentColor'
                }}
                cx={10}
                cy={10}
                r={2}
            />
            <path
                style={{
                    fill: 'none',
                    stroke: 'currentColor',
                    strokeWidth: 2
                }}
                d="m10,10 5,5z"
            />
        </g>
    </svg>
);

export const ExtrudeIcon = () => (
    <svg width={20} height={20} viewBox="0 0 20 20">
        <g>
            <path
                style={{
                    fill: 'currentColor',
                    stroke: 'none'
                }}
                d="m5,14 4,0 0,-7 -2,0 3,-3 3,3 -2,0 0,7 4,0 0,2 -10,0 0,-2z"
            />
        </g>
    </svg>
);